import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    nested: {
        paddingLeft: theme.spacing(4),
        color: theme.palette.text.primary,
    },
}));
